import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import classnames from 'classnames';
import { TextWithMwe } from '../MweSearch/search-components/TextWithMwe';
import DownloadButtons from './DownloadButtons';
import './index.css';

class TaggedMweResults extends Component {

  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };

    this.toggle = this.toggle.bind(this);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  populateTabNames(results) {
    return results.map(
      res => (
        <NavItem key={res.id}>
          <NavLink
            className={classnames({ active: this.state.activeTab === res.id }, 'cursor-pointer')}
            onClick={() => this.toggle(res.id)}
          >
            {res.name}
          </NavLink>
        </NavItem>
      ));
  }

  populateTabContent(results) {
    return results.map(
      res => (
        <TabPane tabId={res.id} key={res.id}>
          <Row>
            <Col sm="12">
              <Card className="mt-3">
                <CardHeader>
                  <DownloadButtons fileName={res.name} text={res.rawData} mweList={res.mweList}/>
                </CardHeader>
                <CardBody>
                  <TextWithMwe data={res.data}/>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </TabPane>
      ));
  }

  render() {
    const { results } = this.props;
    return (
      <div className="m-2">
        <Nav tabs>
          {this.populateTabNames(results)}
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          {this.populateTabContent(results)}
        </TabContent>
      </div>
    );
  }
}

export default TaggedMweResults;
